<script lang="ts" setup>
import { setCanonical, setRobotsMeta } from '@jaaluu/composables/useLandingSeo';
import { getLangSubdomain } from '@jaaluu/utils/subdomain';
import { watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

// Landing pages and /welcome set their own canonical (they exist as distinct
// per-language routes). This covers every other app page - home, grammar,
// feeds, category, etc. - which previously had no canonical at all and were
// reachable identically on the bare domain, www, and every language subdomain.
//
// These app pages must also stay out of search results (per seo/jaaluu.com/
// Main-Description.md): they're per-user content reachable under every
// lang-native/lang-foreign combination, so indexing them would just be
// duplicate/thin-content noise. robots.txt intentionally still allows
// crawling them - noindex only works if Googlebot can fetch the page and see
// this tag; a robots.txt Disallow here would hide the tag instead.
watch(
  () => route.fullPath,
  () => {
    if (!route.params.langForeign) return;
    const subdomain = getLangSubdomain() || 'en';
    setCanonical(`https://${subdomain}.jaaluu.com${route.fullPath}`);
    setRobotsMeta('noindex, follow');
  },
  { immediate: true }
);
</script>

<template>
    <router-view />
</template>

<style scoped lang="scss">

</style>
